import { render, staticRenderFns } from "./TeamsGrid.vue?vue&type=template&id=51b1907a&scoped=true"
import script from "./TeamsGrid.vue?vue&type=script&lang=js"
export * from "./TeamsGrid.vue?vue&type=script&lang=js"
import style0 from "./TeamsGrid.vue?vue&type=style&index=0&id=51b1907a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1907a",
  null
  
)

export default component.exports